document.addEventListener("latte:init", init);

//create a variable for scroll interval counter
var scrollCheckInterval;

function init () {

  // Hide header on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var navbarHeight = $(".lazy-sticker").offset() ? $(".lazy-sticker").offset().top : 0;
  var pdpStickerHeight = $(".pdp-sticker").offset() ? $(".pdp-sticker").offset().top : 0;
  var pdpStickerPlaceholderHeight = $(".pdp-sticker-placeholder").offset() ? $(".pdp-sticker-placeholder").offset().top : 0;
  var navDown = false;

  function stickerSize() {
    stickyText = $(".sticky-top-row").width();
    stickyTitle = $(".sticky-title").width();
    stickyButtons = $(".sticky-bottom-row").width();
    stickyButton = $(".sticky-bottom-row .buttons").width();
    stickyContent = $(".product-sticky-content").width();

    if(stickyText > (stickyContent - stickyButtons)) {
      $(".product-sticky-content").removeClass("short-name");
      if(stickyText > (stickyContent)) {
        $(".sticky-bottom-row").addClass("wide");
        if ($(window).width() >= 768) {
          $(".sticky-title").addClass("overflow");
          $(".upper").hide();
          $(".lower").show();
        $(".sticky-bottom-row").addClass("wide");
        } else {
          if(stickyTitle > stickyContent)  {
            $(".sticky-top-row").addClass("two-row");
          }
        }
      }
    }
  }

  if (pdpStickerHeight) {
    stickerSize();

    $(window).resize(function(event){
        stickerSize();
    });
  }


  $(window).scroll(function(event){
      didScroll = true;
  });

  //clearing interval on pjax and pageload
  if (scrollCheckInterval) {
    clearInterval(scrollCheckInterval);
  }

    //set interval to check if page has scrolled
    scrollCheckInterval = setInterval(function () {
      if (didScroll) {
          hasScrolled();
          didScroll = false;
      }
  }, 250);

  function hasScrolled() {
      var scrollTop = $(this).scrollTop();
      var mastheadHeight = $(".masthead").height();

      //engage HEADER stickyness after the nav bar scrolls out of view
      if (scrollTop > navbarHeight) {
        if (scrollTop < lastScrollTop ) {
          $('.lazy-sticker').addClass('stuck');
        }
      } else {
        $('.lazy-sticker').removeClass('stuck');
      }

    //if the masthead is stuck work the PDP sticky header
    if (navDown) {
      //engage PDP stickyness after the PDP bar scrolls out of view
      if ((scrollTop + mastheadHeight > pdpStickerHeight) && (pdpStickerPlaceholderHeight < scrollTop)) {
        //only if placeholder scrolls out of view
          $('.pdp-sticker').addClass('stuck');
      } else if (pdpStickerPlaceholderHeight < scrollTop + mastheadHeight){
        //if sticky pdp placeholder is above the fold dont unstick it
      } else {
        $('.pdp-sticker').removeClass('stuck');
      }
    } else {
      //if masthead is not stuck engage PDP stickyness after the PDP bar scrolls out of view
      if (scrollTop > pdpStickerHeight) {
        $('.pdp-sticker').addClass('stuck');
      } else {
        $('.pdp-sticker').removeClass('stuck');
      }
    }

    //follow masthead height at the top of page
    if (mastheadHeight - scrollTop > 1) {
      $('.pdp-sticker').css('top', (mastheadHeight - scrollTop));
    } else {
      $('.pdp-sticker').removeAttr( 'style' );
    }

      // If scrolled down and past the navbar, add class .nav-up.
      if (scrollTop > lastScrollTop && scrollTop > (navbarHeight + mastheadHeight)){
          // Scroll Down
          navDown = false;
          $('.lazy-sticker').removeClass('nav-down').addClass('nav-up');
          if (pdpStickerHeight) {
            $('.pdp-sticker').removeClass('with-nav');
          }
      } else if (scrollTop > lastScrollTop) {

      } else {
        // Scroll Up
        if(scrollTop + $(window).height() < $(document).height()) {
          stickerOnScrollUp();
        }
      }

      lastScrollTop = scrollTop;

      //when you hit the bottom of the page show the nav
    	if (($(document).height() - ($(window).height() + scrollTop)) / $(document).height() === 0) {
        $('.lazy-sticker').removeClass('nav-up').addClass('stuck');
        $('.pdp-sticker').addClass('with-nav').removeAttr( 'style' );
    	}

      function stickerOnScrollUp() {
        //pop the nav down
        navDown = true;
        $('.lazy-sticker').removeClass('nav-up').addClass('nav-down');
        $('.pdp-sticker').addClass('with-nav').removeAttr( 'style' );
        //accomidate for pdp-sticky-nav if we have it
        if (pdpStickerHeight && pdpStickerHeight < scrollTop  + mastheadHeight) {
          $('.lazy-sticker').removeClass('nav-down');
        }
      }

  }
}



//////////////////
// WEBPACK FOOTER
// ./public/js/stickers.js
// module id = 92
// module chunks = 0